import React from 'react';
import Page from 'framework7-react/components/page';
import II18 from '../../translate/II18';

import PropTypes from 'prop-types';
import {
  DOC_TYPE_IMMEDIATE_CONFIRMATION,
  DOC_TYPE_INFORMATION
} from '../../helpers/utils';
import DesktopFullPage from '../../desktop/DesktopFullPage';
import ViewerContent from './ViewerContent';
import withViewer from '../withViewer';
import withDocumentCommonUI from '../../helpers/withDocumentCommonUI';

const ViewerPageContent = withDocumentCommonUI(ViewerContent);

class Viewer extends React.Component {
  goBack = () => {
    this.props.navigateBack();
  };

  render() {
    const {
      document: documentItem,
      scanEnded,
      confirmed,
      showAcceptDoneButton,
      onShowConfirmationDialog,
      onShowUnConfirmationDialog,
      printAttachment,
      documentCanNavigateBack,
      documentRejectionAllowed
    } = this.props;

    if (!documentItem) {
      // noinspection CheckTagEmptyBody
      return <Page className={'errorPage'}></Page>;
    }

    const docType = documentItem.type;

    const scrollToEndOptionEnabled =
      documentItem.attributes.scrollToEndOptionEnabled || 1;

    const isInfoDocument = documentItem.type === DOC_TYPE_INFORMATION;

    return (
      <DesktopFullPage
        disableBack={!documentCanNavigateBack}
        goBack={this.goBack}
        popUpId={'viewer-popup'}
        documentName={documentItem.name}
        pageSideId={'viewerContent'}
        pageContent={<ViewerPageContent {...this.props} />}
        actionsList={[
          {
            visible:
              (docType === DOC_TYPE_IMMEDIATE_CONFIRMATION &&
                !confirmed &&
                !scrollToEndOptionEnabled) ||
              showAcceptDoneButton,
            id: 'acceptButton',
            className: 'main-button',
            title: II18.get(
              showAcceptDoneButton ? 'list_done' : 'title_confirm'
            ),
            onClick: () =>
              showAcceptDoneButton
                ? this.props.onDocumentDone(true)
                : onShowConfirmationDialog(),
            materialIcon: 'check'
          },
          {
            visible:
              docType === DOC_TYPE_IMMEDIATE_CONFIRMATION &&
              confirmed &&
              !scanEnded,
            id: 'cancelButton',
            className: (!showAcceptDoneButton ? 'main-button' : '') + ' cancel',
            title: II18.get('title_unconfirm'),
            onClick: () => onShowUnConfirmationDialog(),
            materialIcon: 'block'
          },
          {
            visible:
              docType === DOC_TYPE_INFORMATION ||
              docType === DOC_TYPE_IMMEDIATE_CONFIRMATION,
            id: 'print',
            onClick: printAttachment,
            title: II18.get('title_print'),
            materialIcon: 'print'
          },
          {
            visible: docType === DOC_TYPE_INFORMATION,
            id: 'download',
            onClick: this.props.doDownloadAttachment,
            title: II18.get('title_download'),
            materialIcon: 'file_download'
          },
          {
            visible: !isInfoDocument && documentRejectionAllowed && !scanEnded,
            id: 'rejectDocument',
            onClick: this.props.onRejectDocument,
            title: II18.get('title_reject'),
            materialIcon: 'block'
          },
          {
            visible: documentCanNavigateBack,
            id: 'closeButton',
            onClick: this.goBack,
            title: II18.get('title_close'),
            materialIcon: 'clear'
          }
        ]}
      />
    );
  }
}

Viewer.propTypes = {
  onRejectDocument: PropTypes.func,
  documentRejectionAllowed: PropTypes.bool,
  document: PropTypes.object,
  doDownloadAttachment: PropTypes.func,
  renderSender: PropTypes.func,
  renderUserCredential: PropTypes.func,
  doPrintAttachment: PropTypes.func,
  navigateBack: PropTypes.func,
  onDocumentDone: PropTypes.func,
  scanEnded: PropTypes.bool,
  confirmed: PropTypes.bool,
  open: PropTypes.bool,
  documentCanNavigateBack: PropTypes.bool,
  showAcceptDoneButton: PropTypes.bool,
  onShowConfirmationDialog: PropTypes.func,
  onShowUnConfirmationDialog: PropTypes.func,
  printAttachment: PropTypes.func
};

export default withViewer(Viewer);
